export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-500 rounded-3xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-background-50/10 rounded-full blur-3xl"></div>
          <div className="relative flex-1">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">随时随地，畅快吃瓜</h2>
            <p className="text-sm md:text-base text-background-50/80 mt-3 max-w-md leading-relaxed">
              吃瓜官网全面适配移动端，无需下载APP，打开浏览器即可访问。在任何设备上都能获得流畅的吃瓜体验，最新爆料实时推送，不错过任何精彩。
            </p>
            <div className="flex items-center gap-3 mt-5 flex-wrap">
              <div className="px-4 py-2 bg-background-50/15 backdrop-blur-sm rounded-full text-background-50 text-sm font-medium whitespace-nowrap">
                <i className="ri-smartphone-line mr-2"></i>移动端适配
              </div>
              <div className="px-4 py-2 bg-background-50/15 backdrop-blur-sm rounded-full text-background-50 text-sm font-medium whitespace-nowrap">
                <i className="ri-speed-mini-line mr-2"></i>极速加载
              </div>
            </div>
          </div>
          <div className="relative flex-shrink-0">
            <div className="w-36 h-64 bg-background-50/10 backdrop-blur-sm rounded-2xl border border-background-50/20 flex items-center justify-center">
              <i className="ri-smartphone-line text-5xl text-background-50/60"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}